import { api } from 'services/api';

import { DSP_XANDR } from '../../utils/constants';
import {
  ADVERTISERS_URL,
  AGENCIES_URL,
  CAMPAIGNS_URL,
  AGENCIES_BY_ROLE_URL,
  DSP_ADVERTISERS_URL,
  DSP_AGENCIES_URL,
} from './constants';
import {
  Advertiser,
  AdvertisersPagingRequestValues,
  AdvertisersPagingResponse,
  Agency,
  Campaign,
  CreateAdvertiserRequest,
  CreateAgencyRequest,
  UpdateAdvertiserRequest,
  UpdateAgencyRequest,
} from './organizationApiTypes';

const getAgencies = (dsp?: string) => {
  const formattedDsp = dsp && dsp !== DSP_XANDR ? dsp : null;
  const URL = formattedDsp ? `${DSP_AGENCIES_URL}?dsp=${formattedDsp}` : `${AGENCIES_URL}`;

  return api.get<Agency[]>(`${URL}`);
};

const getAgenciesByRole = (dsp?: string) => {
  return api.get<Agency[]>(`${AGENCIES_BY_ROLE_URL}?dsp=${dsp || DSP_XANDR}`);
};

const getAgency = (payload: string) => {
  return api.get<Agency>(`${AGENCIES_URL}/${payload}`);
};

const getAdvertiser = (payload: string) => {
  return api.get<Advertiser>(`${ADVERTISERS_URL}/${payload}`);
};

const createAdvertiser = (payload: CreateAdvertiserRequest) => {
  const { dsp, ...rest } = payload;
  const formattedDsp = dsp && dsp !== DSP_XANDR ? dsp : null;

  if (formattedDsp) {
    return api.post(`${DSP_ADVERTISERS_URL}/${formattedDsp}`, rest);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { dspId, linkedAdvertiserId, ...cleanPayload } = rest;

  return api.post(ADVERTISERS_URL, cleanPayload);
};

const updateAdvertiser = (payload: UpdateAdvertiserRequest) => {
  return api.put(ADVERTISERS_URL, payload);
};

const moveAdvertiser = (advertiserId: string, agencyId: string) => {
  return api.put(`${DSP_ADVERTISERS_URL}/${advertiserId}/agency`, { agencyId });
};

const deleteAdvertiser = (advertiserId: string) => {
  return api.delete(`${DSP_ADVERTISERS_URL}/${advertiserId}`);
};

const createAgency = (payload: CreateAgencyRequest) => {
  return api.post(AGENCIES_URL, payload);
};

const updateAgency = (payload: UpdateAgencyRequest) => {
  return api.put(AGENCIES_URL, payload);
};

const getCampaigns = (payload: string) => {
  return api.get<Campaign[]>(`${CAMPAIGNS_URL}?advertiserId=${payload}`);
};

const getAdvertisers = (payload: AdvertisersPagingRequestValues) => {
  const sortBy = payload.sortBy ? `&sortBy=${payload.sortBy}` : '';
  const direction = payload.direction ? `&direction=${payload.direction}` : '';

  const optionalParamsString = sortBy && direction ? sortBy.concat(direction) : '';

  const formattedDsp = payload.dsp && payload.dsp !== DSP_XANDR ? payload.dsp : null;
  const URL = formattedDsp ? `${DSP_ADVERTISERS_URL}/${formattedDsp}` : `${ADVERTISERS_URL}`;

  return api.get<AdvertisersPagingResponse>(
    `${URL}?page=${payload.page}&size=${payload.size}&agencyId=${payload.agencyId}${optionalParamsString}`,
  );
};

export const orgApi = {
  getAgencies,
  getAgenciesByRole,
  getAgency,
  getAdvertiser,
  getAdvertisers,
  createAdvertiser,
  updateAdvertiser,
  moveAdvertiser,
  deleteAdvertiser,
  getCampaigns,
  createAgency,
  updateAgency,
};
